<template>
  <div class="row background-recovery" style="margin: 0px; overflow-y: hidden">
    <v-container wrap>
      <v-layout justify-center>
        <v-flex xs12 sm7 md7 lg6 xl5>
          <v-card height="95.1vh">
            <v-container bg fill-height grid-list-md text-xs-center>
              <v-layout wrap>
                <v-flex xs8 offset-xs2>
                  <v-layout wrap>
                    <v-flex xs12 mt-4>
                      <v-img
                        :src="require('@/assets/img/0_Skolable.png')"
                      ></v-img>
                    </v-flex>
                    <v-flex xs12 mt-4>
                      <h1>Cita</h1>
                    </v-flex>
                    <v-flex xs12 mt-4 v-if="status === 'loading'">
                      <h4>Verificando...</h4>
                    </v-flex>
                    <v-flex xs12 mt-4 v-else-if="status === 'loaded'">
                      <v-layout wrap>
                        <v-flex xs12>
                          <h4>Nombre</h4>
                          <h2>{{ data.firstName }} {{ data.lastName }}</h2>

                          <h4 class="mt-3">Fecha</h4>
                          <h2>{{ data.visit.date | formatDate }}</h2>

                          <h4 class="mt-3">Cita a</h4>
                          <h2>
                            {{ data.visit.collaborator.firstName }}
                            {{ data.visit.collaborator.lastName }}
                          </h2>
                        </v-flex>
                        <v-flex xs12>
                          <img
                            :src="'data:image/png;base64, ' + data.qr"
                            width="100%"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 mt-4 v-else>
                      <h4>{{ status }}</h4>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      status: null,
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    "$route.params.code"() {
      this.load();
    },
  },
  methods: {
    load() {
      this.status = "loading";
      this.$store
        .dispatch("visits/getVisitPerson", this.$route.params.code)
        .then((response) => {
          this.data = response.data;
          this.status = "loaded";
        })
        .catch((error) => {
          switch (error.response.status) {
            case 404:
              this.status = "El código de cita no existe";
              break;
            default:
              this.status =
                "No logramos verificar la existencia del código de cita. Intente más tarde.";
          }
        });
    },
  },
};
</script>

<style>
.background-recovery {
  background: url(../../assets/recovery/qrRegister.png) no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
